import { PointerSensor } from '@dnd-kit/core';

const INTERACTIVE_SELECTOR = 'input, textarea, select, option, button, [contenteditable="true"]';

/**
 * Pointer sensor that does not start a drag from text fields or other
 * interactive controls inside a draggable row.
 */
export class SmartPointerSensor extends PointerSensor {
    static activators = [
        {
            eventName: 'onPointerDown',
            handler: ({ nativeEvent: event }) => {
                if (!event.isPrimary || event.button !== 0) {
                    return false;
                }
                const target = event.target instanceof Element ? event.target : event.target?.parentElement;
                if (target instanceof Element && target.closest(INTERACTIVE_SELECTOR)) {
                    return false;
                }
                return true;
            },
        },
    ];
}
